import { useMutation, useQueryClient } from "@tanstack/react-query";
import _ from "underscore";
import TenantAPI from "../../api/TenantAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
  groupTagData,
} from "../../../utils/GeneralUtils";

const useUpdateTagGroup = () => {
  const queryClient = useQueryClient();

  const updateTagGroup = useMutation({
    mutationFn: ({
      groupName,
      payload,
      scope,
    }: {
      groupName: string;
      payload: any;
      scope: any;
      onSuccess?: () => void;
    }) => {
      return TenantAPI.updateTagGroup({
        groupName: groupName,
        payload: payload,
        scope: scope,
      }).then((data) => {
        const newRecords = data.data.data;
        const tagData = queryClient.getQueryData<any>(["tags", scope]);
        const newTags = [...tagData.tags];

        for (const tagRecord of newRecords) {
          const tagIndex = _.findIndex(newTags, { id: tagRecord.id });

          if (tagIndex > -1) {
            newTags[tagIndex] = tagRecord;
          }
        }

        const newTagGroups = groupTagData(newTags);

        queryClient.setQueryData(["tags", scope], {
          tags: newTags,
          tagGroups: newTagGroups,
        });
      });
    },
    onSuccess: (_, { onSuccess }) => {
      callFunctionIfExists(onSuccess);
    },
  });

  return {
    updateTagGroup: updateTagGroup.mutate,
    updatingGroup: updateTagGroup.isPending,
    updateGroupError: updateTagGroup.error
      ? getErrorMessage(updateTagGroup.error)
      : null,
  };
};

export default useUpdateTagGroup;
